import { render } from "./DirectorioMember.vue?vue&type=template&id=30a247c7&scoped=true"
import script from "./DirectorioMember.vue?vue&type=script&lang=ts"
export * from "./DirectorioMember.vue?vue&type=script&lang=ts"

import "./DirectorioMember.vue?vue&type=style&index=0&id=30a247c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30a247c7"

export default script